<div class="notificationsContentContainer min-h-[34vw]" *transloco="let translate">
    <div class="d-flex justify-content-between align-items-center matDialogBorderBottom">
        <h4 class="matDialogTitle" mat-dialog-title [textContent]="translate('Notifications')"></h4>
        <span class="material-icons mb-3" mat-dialog-close>close</span>
    </div>
    <mat-dialog-content class="mat-typography">
        <app-common-notifications-eventlogs
            [resourceId]="data?.resourceId"
            [sourcePage]="'masters'"
            [notificationsState]="notificationsState"></app-common-notifications-eventlogs>
    </mat-dialog-content>
</div>
